module.exports = __webpack_public_path__ + "static/media/06_tn.4d9bf664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/06_tn.jpg
// module id = 144
// module chunks = 0